import { ToggleStateType } from '@kubit/web-ui-components/toggle/types';
import { commonStyles } from '../commonStyles';
import { ToggleVariant } from '../variants';
export const getRegularStyles = (FOUNDATIONS, FONT) => {
    return {
        [ToggleVariant.REGULAR]: {
            [ToggleStateType.DEFAULT_SELECTED]: {
                ...commonStyles(FOUNDATIONS, FONT),
                wrapper: {
                    ...commonStyles(FOUNDATIONS, FONT).wrapper,
                    background_color: FOUNDATIONS.color_comp_forms_toggle_selected_bg,
                },
                icon: {
                    ...commonStyles(FOUNDATIONS, FONT).icon,
                    color: FOUNDATIONS.color_comp_forms_toggle_selected_icon,
                },
                thumb: {
                    ...commonStyles(FOUNDATIONS, FONT).thumb,
                    background_color: FOUNDATIONS.color_comp_forms_toggle_selected_thumb_bg,
                },
            },
            [ToggleStateType.DEFAULT_UNSELECTED]: {
                ...commonStyles(FOUNDATIONS, FONT),
                wrapper: {
                    ...commonStyles(FOUNDATIONS, FONT).wrapper,
                    background_color: FOUNDATIONS.color_comp_forms_toggle_unselected_bg,
                },
                icon: {
                    ...commonStyles(FOUNDATIONS, FONT).icon,
                    color: FOUNDATIONS.color_neutral_icon_150,
                },
                thumb: {
                    ...commonStyles(FOUNDATIONS, FONT).thumb,
                    background_color: FOUNDATIONS.color_comp_forms_toggle_unselected_thumb_bg,
                },
            },
            [ToggleStateType.DISABLED_SELECTED]: {
                ...commonStyles(FOUNDATIONS, FONT),
                wrapper: {
                    ...commonStyles(FOUNDATIONS, FONT).wrapper,
                    background_color: FOUNDATIONS.color_accent_disabled_bg_50,
                },
                thumb: {
                    ...commonStyles(FOUNDATIONS, FONT).thumb,
                    background_color: FOUNDATIONS.color_accent_disabled_bg_300,
                },
                icon: {
                    ...commonStyles(FOUNDATIONS, FONT).icon,
                    color: FOUNDATIONS.color_accent_disabled_icon_50,
                },
            },
            [ToggleStateType.DISABLED_UNSELECTED]: {
                ...commonStyles(FOUNDATIONS, FONT),
                wrapper: {
                    ...commonStyles(FOUNDATIONS, FONT).wrapper,
                    background_color: FOUNDATIONS.color_accent_disabled_bg_50,
                },
                thumb: {
                    ...commonStyles(FOUNDATIONS, FONT).thumb,
                    background_color: FOUNDATIONS.color_accent_disabled_bg_300,
                },
                icon: {
                    ...commonStyles(FOUNDATIONS, FONT).icon,
                    color: FOUNDATIONS.color_accent_disabled_icon_50,
                },
            },
        },
    };
};
//# sourceMappingURL=regular.js.map